// DemoModeBanner - Shows when admin is previewing an onboarding step
import { useNavigate } from 'react-router-dom'
import { useAdmin } from '../context/AdminContext'
import { STAGE_INFO } from '../config/stages'

const DemoModeBanner = () => {
  const { demoMode, isDemoMode, stopDemoMode } = useAdmin()
  const navigate = useNavigate()

  if (!isDemoMode) return null

  const stageName = STAGE_INFO[demoMode?.stage]?.name || 'Unknown Step'

  const handleExit = () => {
    stopDemoMode()
    navigate('/admin')
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-purple-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Presentation icon */}
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span className="font-semibold">Demo Mode</span>
          <span className="text-purple-200">
            Previewing: {stageName}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-purple-200 text-sm hidden sm:inline">
            Press ESC or click to exit
          </span>
          <button
            onClick={handleExit}
            className="px-3 py-1.5 bg-white/20 hover:bg-white/30 rounded-md text-sm font-medium transition-colors flex items-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
            Exit Demo
          </button>
        </div>
      </div>
    </div>
  )
}

export default DemoModeBanner
